(function () {
  var KEY = 'wishlist:v1';
  var EVT = 'wishlist:change';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent(EVT, { detail: { list: list } }));
  }
  function has(handle) { return read().indexOf(handle) > -1; }
  function add(handle) {
    var list = read();
    if (list.indexOf(handle) === -1) { list.push(handle); write(list); }
  }
  function remove(handle) {
    var list = read().filter(function (h) { return h !== handle; });
    write(list);
  }
  function toggle(handle) {
    if (has(handle)) { remove(handle); return false; }
    add(handle); return true;
  }
  function money(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    return '€' + (n / 100).toFixed(2).replace(/\.00$/, '');
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function imgSrc(product, width) {
    var img = product && product.featured_image;
    if (!img) return null;
    if (typeof img === 'string') return img.replace(/(\.(?:jpg|jpeg|png|gif|webp))/i, '_' + width + 'x$1');
    if (img.src) return img.src.replace(/(\.(?:jpg|jpeg|png|gif|webp))/i, '_' + width + 'x$1');
    return null;
  }

  // --- Count badge on header heart icon ---
  function refreshBadges() {
    var count = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) {
      badge.textContent = String(count);
      badge.setAttribute('data-empty', count === 0 ? 'true' : 'false');
    });
  }

  // --- PDP heart button toggle ---
  function refreshHeartButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      var isSaved = has(handle);
      btn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      btn.classList.toggle('is-saved', isSaved);
    });
  }
  function bindHearts(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn.dataset.wishlistBound === '1') return;
      btn.dataset.wishlistBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var handle = btn.getAttribute('data-handle');
        if (!handle) return;
        toggle(handle);
      });
    });
  }

  // --- Wishlist page renderer ---
  function wl() {
    return (window.themeStrings && window.themeStrings.wishlist) || {};
  }

  function renderCard(product) {
    var s = wl();
    var url = '/products/' + product.handle;
    var price = money(product.price);
    var compareAt = product.compare_at_price && product.compare_at_price > product.price ? money(product.compare_at_price) : null;
    var region = product.tags ? (product.tags.filter(function (t) { return /^region:/i.test(t); })[0] || '').replace(/^region:\s*/i, '') : '';
    var available = product.available !== false;
    var imgUrl = imgSrc(product, 600);
    var imgSrcset = imgUrl ? imgSrc(product, 300) + ' 300w, ' + imgUrl + ' 600w, ' + imgSrc(product, 900) + ' 900w' : '';
    var altText = (product.featured_image && product.featured_image.alt) || product.title || '';

    var html =
      '<div class="wishlist-item" data-wishlist-card data-handle="' + escapeHtml(product.handle) + '">' +
        '<a class="product" href="' + escapeHtml(url) + '">' +
          '<div class="img-area">' +
            (available ? '' : '<span class="oos">' + escapeHtml(s.soldOut || 'Sold out') + '</span>') +
            (imgUrl
              ? '<img src="' + escapeHtml(imgUrl) + '" srcset="' + escapeHtml(imgSrcset) + '" sizes="(max-width: 820px) 50vw, 25vw" alt="' + escapeHtml(altText) + '" loading="lazy" width="600" height="600">'
              : '<span class="no-img">◆</span>') +
          '</div>' +
          (region ? '<div class="region">' + escapeHtml(region) + '</div>' : '') +
          '<h3>' + escapeHtml(product.title) + '</h3>' +
          '<div class="price">' + price + (compareAt ? ' <span class="compare">' + compareAt + '</span>' : '') + '</div>' +
          '<span class="view-btn">' + escapeHtml(s.view || 'View') + ' →</span>' +
        '</a>' +
        '<button class="wishlist-remove" type="button" data-wishlist-remove data-handle="' + escapeHtml(product.handle) + '" aria-label="' + escapeHtml(s.removeLabel || 'Remove from wishlist') + '">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M3 3L11 11M11 3L3 11"/></svg>' +
          '<span>' + escapeHtml(s.remove || 'Remove') + '</span>' +
        '</button>' +
      '</div>';
    return html;
  }

  function showEmpty(grid) {
    var s = wl();
    grid.setAttribute('data-state', 'empty');
    grid.innerHTML =
      '<div class="wishlist-empty-state">' +
        '<svg viewBox="0 0 48 48" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M41 9.2a11 11 0 0 0-15.6 0L24 10.6l-1.4-1.4a11 11 0 0 0-15.6 15.6L24 42.4l17-17a11 11 0 0 0 0-15.6z"/>' +
        '</svg>' +
        '<p>' + escapeHtml(s.emptyHeading || 'Your cellar is empty.') + '</p>' +
        '<p class="wishlist-empty-sub">' + escapeHtml(s.emptySub || 'Save bottles for later by tapping the heart on any wine.') + '</p>' +
        '<a class="wishlist-cta" href="/collections/all">' + escapeHtml(s.discover || 'Discover wines') + '</a>' +
      '</div>';
  }

  function renderWishlistPage(grid) {
    var handles = read();
    if (!handles.length) { showEmpty(grid); return; }

    grid.setAttribute('data-state', 'loading');
    grid.innerHTML = '';

    var promises = handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(promises).then(function (products) {
      var foundAny = false;
      var html = '';
      products.forEach(function (p, i) {
        if (!p) {
          // Product missing/deleted — purge from storage silently.
          remove(handles[i]);
          return;
        }
        foundAny = true;
        html += renderCard(p);
      });
      if (!foundAny) { showEmpty(grid); return; }
      grid.setAttribute('data-state', 'loaded');
      grid.innerHTML = html;

      grid.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var h = btn.getAttribute('data-handle');
          remove(h);
          var card = btn.closest('[data-wishlist-card]');
          if (card) {
            card.style.transition = 'opacity .2s ease';
            card.style.opacity = '0';
            setTimeout(function () { card.remove(); if (!grid.children.length) showEmpty(grid); }, 180);
          }
        });
      });
    });
  }

  // --- Wire up on load ---
  function init() {
    refreshBadges();
    refreshHeartButtons();
    bindHearts(document);
    var grid = document.getElementById('wishlist-grid');
    if (grid) renderWishlistPage(grid);
  }

  document.addEventListener(EVT, function () {
    refreshBadges();
    refreshHeartButtons();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  // Public API (handy for debugging)
  window.Wishlist = { read: read, add: add, remove: remove, toggle: toggle, has: has };
})();
